import { PropsWithChildren } from 'react';
import { Box } from 'reflexbox';
import styled from 'styled-components';

import { tokens } from '@treams/treams-ui';

const Container = styled(Box)`
	border: 1px solid ${tokens.border.subtle};
	background-color: ${tokens.surface.white};
	border-radius: ${tokens.radius.md}px;
	box-shadow: ${tokens.shadow.xs};
`;

export default function InboxPersonalCard(props: PropsWithChildren<{}>) {
	return <Container>{props.children}</Container>;
}
